import { Icon } from '@chakra-ui/react';

const PCImageIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M28.79,5.94c-0.68-2.63-2.8-4.5-5.53-4.88c-0.04-0.01-0.08-0.03-0.12-0.05H6.86C6.35,1.14,5.82,1.21,5.34,1.4
		C2.89,2.35,1.46,4.13,1.07,6.73C1.02,7.02,1.01,7.31,1.01,7.6c0,4.93,0,9.85,0,14.78c0,3.3,2.27,5.98,5.52,6.54
		c0.29,0.05,0.6,0.07,0.9,0.07c4.36,0,7.65,0.01,12.01,0c0.69-0.31,0.88-1.41-0.06-1.72c-4.3,0-7.49-0.15-11.79-0.16
		c-2.35,0-4.25-1.6-4.66-3.91c-0.05-0.29-0.06-0.58-0.06-0.87c0-4.89,0-9.78,0-14.67c0-2.39,1.52-4.24,3.86-4.7
		c0.32-0.06,0.65-0.08,0.98-0.08c4.89,0,9.78,0,14.67,0.01c2.39,0,4.3,1.62,4.69,3.98c0.05,0.29,0.05,0.6,0.05,0.9
		c0,2.41,0,4.83,0,7.24c0,2.44,0,4.88,0,7.32c0,1.64-0.64,2.97-1.98,3.93c-0.81,0.59-1.74,0.86-2.74,0.86c-0.02,0-0.04,0-0.06,0
		c-0.75,0.54-0.78,1.52,0.01,1.87c0.07,0,0.14,0,0.21,0c3.21-0.01,5.99-2.5,6.38-5.7c0.01-0.05,0.03-0.1,0.05-0.15V6.86
		C28.92,6.55,28.87,6.24,28.79,5.94z"/>
			<g>
				<path class="st0" d="M18.77,6.01c-1.54,0-2.79,1.26-2.8,2.8c0,1.55,1.25,2.81,2.77,2.81c1.57,0,2.84-1.26,2.83-2.82
			C21.57,7.28,20.29,6.01,18.77,6.01z M18.77,10.61c-0.99,0-1.8-0.81-1.8-1.8s0.81-1.8,1.8-1.8s1.8,0.81,1.8,1.8
			S19.77,10.61,18.77,10.61z"/>
				<g>
					<path class="st0" d="M18.69,16.7c-0.73,0.01-0.71,0.01-0.91-0.74c-0.35-1.32-1.19-2.15-2.46-2.4c-1.31-0.25-2.42,0.2-3.17,1.38
				c-0.28,0.44-0.51,0.58-1.04,0.46c-1.28-0.28-2.57,0.64-2.88,1.97c-0.01,0.06-0.02,0.13-0.03,0.19c-0.05,0.22-0.09,0.5-0.39,0.43
				c-0.26-0.07-0.19-0.34-0.17-0.54c0.18-1.61,1.79-2.86,3.44-2.65c0.3,0.04,0.47-0.04,0.65-0.29c0.91-1.25,2.14-1.79,3.61-1.54
				c1.47,0.24,2.43,1.19,2.91,2.65c0.12,0.36,0.25,0.51,0.64,0.52c1.78,0.04,3.24,1.48,3.43,3.34c0.18,1.83-0.95,3.57-2.64,4.04
				c-0.24,0.07-0.48,0.12-0.72,0.15c-0.2,0.03-0.44,0.03-0.48-0.24c-0.04-0.29,0.2-0.31,0.4-0.34c0.88-0.14,1.67-0.45,2.23-1.22
				c0.76-1.05,0.91-2.18,0.35-3.36C20.92,17.3,19.95,16.74,18.69,16.7z"/>
					<path class="st0" d="M18.84,23.99c-0.53,0-0.64-0.39-0.66-0.52c-0.03-0.22,0.03-0.36,0.09-0.44c0.14-0.2,0.38-0.23,0.54-0.25
				l0.04-0.01c0.95-0.15,1.57-0.48,2.02-1.1c0.7-0.97,0.81-1.99,0.32-3.04c-0.48-1.03-1.32-1.57-2.5-1.61
				c-0.84,0.01-0.98-0.09-1.2-0.92l-0.02-0.06c-0.32-1.22-1.06-1.95-2.21-2.17c-1.19-0.23-2.17,0.2-2.84,1.24
				c-0.31,0.49-0.65,0.76-1.37,0.6c-1.08-0.24-2.22,0.55-2.5,1.73c-0.01,0.02-0.01,0.05-0.01,0.07c-0.01,0.04-0.01,0.08-0.02,0.12
				l-0.01,0.05c-0.04,0.18-0.1,0.43-0.32,0.56c-0.09,0.05-0.24,0.11-0.45,0.05c-0.51-0.13-0.44-0.65-0.41-0.82
				c0-0.02,0.01-0.04,0.01-0.06c0.09-0.84,0.56-1.65,1.27-2.21c0.73-0.57,1.65-0.84,2.53-0.73c0.19,0.02,0.24,0,0.36-0.16
				c0.99-1.35,2.35-1.93,3.92-1.67c1.53,0.25,2.63,1.24,3.17,2.86c0.1,0.29,0.14,0.3,0.34,0.3c1.93,0.04,3.54,1.6,3.74,3.63
				c0.2,1.99-1.03,3.87-2.88,4.38c-0.25,0.07-0.51,0.12-0.76,0.16C18.96,23.99,18.89,23.99,18.84,23.99z M18.25,16.37
				c0.04,0.01,0.16,0.02,0.28,0.01c-0.17-0.06-0.28-0.16-0.37-0.28C18.19,16.22,18.22,16.33,18.25,16.37z M11.34,15.12
				c0.19,0.02,0.3-0.02,0.42-0.16C11.63,15.05,11.5,15.1,11.34,15.12z"/>
				</g>
			</g>
		</g>

	</Icon>
);

export default PCImageIcon;
